import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import WifiOffRoundedIcon from '@mui/icons-material/WifiOffRounded';
import { FC } from 'react';

import ErrorScreen from '../ErrorScreen/ErrorScreen';
import { logout } from '../../keycloak';

interface AppErrorProps {
  message?: string | null;
  /** Replaces the generic description, for a known failure the user can't retry past. */
  description?: string;
  showLogout?: boolean;
}

const isNetworkError = (message?: string | null) =>
  !!message && /network|timeout|failed to fetch/i.test(message);

const AppError: FC<AppErrorProps> = ({ message, description, showLogout = false }) => {
  const offline = isNetworkError(message);

  return (
    <ErrorScreen
      documentTitle={offline ? 'Connection Lost' : 'Something Went Wrong'}
      icon={
        offline ? (
          <WifiOffRoundedIcon color='error' />
        ) : (
          <ErrorOutlineRoundedIcon color='error' />
        )
      }
      title={offline ? 'Casa will be back shortly' : 'Something went wrong'}
      description={
        description ??
        (offline
          ? "We can't reach the server right now. Check your connection and try again."
          : "This page didn't load as expected. Please try again in a moment.")
      }
      onRetry={() => window.location.reload()}
      onLogout={showLogout ? logout : undefined}
    />
  );
};
export default AppError;
